import { type ReactNode } from "react";
import { XIcon } from "lucide-react";
import { Dialog, DialogClose, DialogContent, DialogTitle } from "~/components/ui/dialog";

interface FullscreenArtifactModalProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  title?: string;
}

export function FullscreenArtifactModal({
  open,
  onClose,
  children,
  title = "Fullscreen view",
}: FullscreenArtifactModalProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) onClose();
      }}
    >
      <DialogContent
        className="sm:max-w-none max-w-none w-[calc(100vw-48px)] h-[calc(100vh-48px)] flex flex-col gap-0 overflow-hidden p-4 pt-1"
        overlayClassName="bg-black/70"
        showCloseButton={false}
      >
        <DialogTitle className="sr-only">{title}</DialogTitle>
        {children}
        <DialogClose className="absolute top-1.5 right-4 p-1.5 rounded hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-colors cursor-pointer focus:outline-hidden [&_svg]:pointer-events-none">
          <XIcon className="size-4" />
          <span className="sr-only">Close</span>
        </DialogClose>
      </DialogContent>
    </Dialog>
  );
}
